import { halClient } from '../../hal';
import { BBModel } from '../../bb_model';
import { context } from '../../constants/context';

class Set {

    constructor(modelClass, company) {
        this.company_id = company.id;
        this.set = {};
        this.modelClass = modelClass;
        this.listeners = [];
        this.listenForPush(company);
        this.collections = {};
        Set.all[this.constructor.group] = Set.all[this.constructor.group] || [];
        Set.all[this.constructor.group].push(this);
    }

    listenForPush(company) {
        if (company.pusherChannelPromise) {
            company.pusherChannelPromise.then((pusherChannel) => {
                this.bindToChannel(pusherChannel);
            });
        }
    }

    addItem(newItem) {
        this.set[newItem.$link('self').href] = newItem;
        this.items = Object.values(this.set);
    }

    updateItem(newItem) {
        const item = this.set[newItem.$link('self').href];
        if (item) {
            if (item.fetching) {
                this.set[newItem.$link('self').href] = newItem;
                this.items = Object.values(this.set);
            } else {
                item.constructor(newItem._data);
            }
        } else {
            this.addItem(newItem);
        }
    }

    getItem(company, id) {
        return new Promise((resolve, reject) => {
            return company.$get(this.constructor.group)
                .then(items => items.$get(this.constructor.model, {id}))
                .then((item) => {
                    const url = item.$link('self').href;
                    if (!this.set[url]) {
                        this.set[url] = new (this.modelClass)(item);
                    }
                    resolve(this.set[url]);
                }, reject);

        });
    }

    handlePush(push, immediate = false) {
        if (push.action === 'destroy') {
            this.pushDelete(push);
            this.callListeners(push);
        } else {
            if (this.set[push.url]) {
                if (this.set[push.url].fetching) {
                    this.set[push.url].action();
                } else {
                    this.initSetItem(push, immediate);
                    this.set[push.url].action();
                }
            } else if (this.fetchRequired(push)) {
                this.initSetItem(push, immediate);
                this.set[push.url].action();
            }
        }
    }

    fetchRequired(push){
        return true;
    }

    initSetItem(push, immediate = false) {
        let item = this.set[push.url];
        this.set[push.url] = {
            fetching: true,
            action: _.debounce(() => {
                halClient.$get(push.url, {no_cache: true}).then((response) => {
                    if (item)
                        item.constructor(response);
                    else
                        item = new (this.modelClass)(response);
                    push.object = item;
                    switch (push.action) {
                        case 'create':
                            this.addItem(item);
                            this.callListeners(push);
                            break;
                        case 'update':
                            this.updateItem(item);
                            this.callListeners(push);
                            break;
                    }
                });
            }, 1000, immediate)
        };
    }

    pushDelete(push) {
        if (this.set[push.url]) delete this.set[push.url];
        this.items = Object.values(this.set);
    }

    bindToChannel(channel) {
        channel.bind(this.constructor.model, (push) => {
            if (push.url){
                push.url = push.url.replace('/v1/', '/' + context.apiVersion + '/');
            }
            return this.handlePush(push);
        }, this);
    }

    findListenerIndex(callback, context) {
        return this.listeners.findIndex((listener) => {
            return listener.callback === callback && listener.context === context;
        });
    }

    addListener(callback, context) {
        const index = this.findListenerIndex(callback, context);
        if (index === -1) this.listeners.push({callback, context});
    }

    callListeners(push) {
        push.set = this;
        for (const listener of this.listeners) listener.callback.call(listener.context, push);
    }

    removeListener(callback, context) {
        if (context) {
            const index = this.findListenerIndex(callback, context);
            if (index > -1) this.listeners.splice(index, 1);
        } else {
            this.listeners = this.listeners.filter(listener => listener.callback !== callback);
        }
    }

    static delete(url, companyId) {
        const company = BBModel.Admin.Company.all[companyId];
        if (company) {
            company[this.group].pushDelete({url});
        }
    }

    static updateAll(url, companyId) {
        const push = {
            action: 'update',
            model: this.model,
            group: this.group,
            url
        };

        const companySet = this.all[companyId];
        if (companySet) {
            companySet.handlePush(push);
        }
    }

    static ignoreUpdate(model, updated_at = null) {
        Set.ignored_updates[model.id] = {updated_at};
    }

    static reset(){
        Set.ignored_updates = {};
        Set.all = {};
    }

    $query(modelClass, company, params) {
        const group = this.constructor.group;
        return new Promise((resolve, reject) => {
            if (this.items) {
                return resolve(this);
            } else {
                return company.$get(group, params).then((resource) => {
                    resource.$get(group).then((items) => {
                        items.forEach(item => this.updateItem(new (modelClass)(item)));
                        resolve(this);
                    });
                }, reject);
            }
        });
    }

}

Set.ignored_updates = {};
Set.all = {};

export {
    Set
};

